import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                item: 'onItemClick'
            }
        }

        this.$items = this.$('item')
    }

    init() {
        this.touchStartBind = () => {
            this.isTouch = true;
        }
        this.el.addEventListener('touchstart', this.touchStartBind, { once: true })

        this.leave = (e) => {
            if(this.isTouch) return

            this.call('setModel', false, 'TeamListCanvas');
        }

        this.enter = (e) => {
            if(this.isTouch) return

            const infos = JSON.parse(this.getData('infos', e.currentTarget))
            this.call('setModel', infos.model, 'TeamListCanvas');
        }

        for(let item of this.$items) {
            item.addEventListener('focusout', this.leave)
            item.addEventListener('mouseleave', this.leave)
            item.addEventListener('mouseenter', this.enter)
            item.addEventListener('focusin', (e) => {
                if(e.target.classList.contains('focus-visible')) {
                    this.enter(e)
                }
            })
        }

        requestAnimationFrame(() => {
            this.checkUrl()
        })
    }

    checkUrl() {
        const url = new URL(window.location.href)
        const teamMemberId = url.searchParams.get('teamMember')
        const anim = url.searchParams.get('anim')

        if(anim) {
            this.call('setDefaultAnimation', anim, 'TeamModalCanvas')
        }

        if(teamMemberId) {
            const teamMemberItem = Array.from(this.$items).map(item => {
                let infos = JSON.parse(this.getData('infos', item))
                infos.listEl = item;
                return infos
            }).find(item => item.id == teamMemberId);

            teamMemberItem && this.call('show', teamMemberItem, 'TeamModal');
            teamMemberItem && this.call('scrollTo', { target: teamMemberItem.listEl, options: {
                offset: -window.innerHeight/2
            } }, 'Scroll');
        }
    }

    onItemClick(e) {
        let item = e.curTarget;

        this.call('setModel', false, 'TeamListCanvas');
        this.call('show', JSON.parse(this.getData('infos',item)), 'TeamModal')
    }

    destroy() {
        this.el.removeEventListener('touchstart', this.touchStartBind)

        for(let item of this.$items) {
            item.removeEventListener('focusout', this.leave)
            item.removeEventListener('mouseleave', this.leave)
            item.removeEventListener('mouseenter', this.enter)
            item.removeEventListener('focusin', this.enter)
        }
    }
}
